import { ConsentOption } from '@models/user.model';

let logRocketInitialized = false;
let LogRocketModule: any = null;

/**
 * Convert ConsentOption to boolean flags for LogRocket initialization
 */
export const consentOptionToFlags = (
  option: ConsentOption
): { allowRecording: boolean; allowIdentification: boolean } => {
  switch (option) {
    case 'identified':
      return { allowRecording: true, allowIdentification: true };
    case 'decline':
      return { allowRecording: false, allowIdentification: false };
  }
};

export const initializeLogRocket = async (
  allowRecording: boolean,
  allowIdentification: boolean,
  userData?: { userId: string; email: string; role: string }
) => {
  const DEBUG = false;
  if (DEBUG) return;

  if (allowRecording && !logRocketInitialized) {
    // Only import LogRocket if user consented - this prevents any network requests
    if (!LogRocketModule) {
      const { default: LogRocket } = await import('logrocket');
      LogRocketModule = LogRocket;
    }

    LogRocketModule.init(process.env.REACT_APP_LOGROCKET_ID || '', {
      network: {
        requestSanitizer: (request: any) => {
          if (
            request.url.includes('/signIn') ||
            request.url.includes('/signInWithConfirm') ||
            request.url.includes('/redeemIntegrationCode')
          ) {
            request.body = '';
          }
          return request;
        },
      },
    });
    logRocketInitialized = true;
  }

  if (logRocketInitialized && allowIdentification === true && userData) {
    LogRocketModule.identify(userData.userId, {
      userId: userData.userId,
      email: userData.email,
      role: userData.role,
      environment: window.location.hostname,
      nodeEnv: process.env.NODE_ENV,
    });
  }
};

export const isLogRocketInitialized = () => logRocketInitialized;
